import "../atoms/grecaptcha";

function updateSubdomainInForm(companyId, nameId, subdomainId) {
  let company = document.getElementById(companyId).value;
  let name = document.getElementById(nameId).value;
  let slug = "";

  if (name != "") {
    slug = name;
  }

  if (company != "") {
    slug = company;
  }

  let xhr = new XMLHttpRequest();
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      const response = JSON.parse(xhr.responseText);
      document.getElementById(subdomainId).value = response.url;
    }
  };

  xhr.open("GET", "/utils/urlify.json?slug=" + slug);
  xhr.send();
}

function initTrialForm() {
  initGrecaptcha();

  document.getElementById("trial_form_name").addEventListener(
    "change",
    function () {
      updateSubdomainInForm(
        "trial_form_name",
        "trial_form_admin_name",
        "trial_form_url"
      );
    },
    false
  );

  document.getElementById("trial_form_admin_name").addEventListener(
    "change",
    function () {
      updateSubdomainInForm(
        "trial_form_name",
        "trial_form_admin_name",
        "trial_form_url"
      );
    },
    false
  );
}

initTrialForm();
